module.exports = __webpack_public_path__ + "static/media/burner.d39743ac.svg";